// extracted by mini-css-extract-plugin
export default {"container":"DetailedProgramSection_container__Fc54B"};